var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 text-center"},[_c('button',{staticClass:"ml-3 btn btn-light",attrs:{"type":"button"},on:{"click":function($event){return _vm.onSave()}}},[_vm._v("저장")]),_c('button',{staticClass:"ml-3 btn btn-light",attrs:{"type":"button"},on:{"click":function($event){return _vm.onReset()}}},[_vm._v("초기화")])])
}
var staticRenderFns = []

export { render, staticRenderFns }